import Vue from 'vue'
// import App from './App.vue'
// import wcv from './views/WebCrawlersView.vue'
// import s1 from './views/s1.vue'
// import index from './views/indexView.vue'
import tempView from './views/tempView.vue'
import router from './router/testIndex'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false

Vue.use(ElementUI)

new Vue({
  router,
  store,
  render: h => h(tempView)
}).$mount('#app')
